import {
  ChartOfAccounts,
  CoAManagedType,
  CoAManagingApplication,
  CoaTree,
  LedgerType,
} from "../apiHooks/chartOfAccounts/chartOfAccounts.types";
import { NOCODE } from "../apiHooks/chartOfAccounts/chartOfAccounts.constants";

/** Account type filter for form setup — includes "both" for expenses + revenues. */
export type FormAccountType = LedgerType.Expenses | LedgerType.Revenues | "both";

export const FORM_ACCOUNT_TYPE_BOTH = "both";

export const isFormAccountType = (value: unknown): value is FormAccountType =>
  value === LedgerType.Expenses || value === LedgerType.Revenues || value === FORM_ACCOUNT_TYPE_BOTH;

export const toFormAccountType = (value: string | null | undefined): FormAccountType | undefined =>
  isFormAccountType(value) ? value : undefined;

export const getCoaBreakdownTrees = (trees: CoaTree[]) => trees.filter((tree) => !tree.ledger_type && tree.enabled);

export const getCoaLedgerTrees = (trees: CoaTree[], ledgerType: LedgerType) =>
  trees.filter((tree) => tree.ledger_type === ledgerType);

export const getCoaBreakdownAndLedgerTrees = (trees: CoaTree[], accountType: FormAccountType) =>
  trees.filter((tree) => {
    if (!tree.ledger_type && tree.enabled) return true;
    if (accountType === FORM_ACCOUNT_TYPE_BOTH) {
      return tree.ledger_type === LedgerType.Expenses || tree.ledger_type === LedgerType.Revenues;
    }
    return tree.ledger_type === accountType;
  });

export const checkIsNocodeAccountCode = (accountCode: string) => accountCode === NOCODE;

export const checkIsFinCoA = (coa: ChartOfAccounts) =>
  coa.managed_type === CoAManagedType.Application && coa.managing_application === CoAManagingApplication.Financials;
